import styled from 'styled-components';

import {
  colorAccent50,
  colorBlack200,
  colorGrey50,
  colorGrey75,
  colorWhite,
  mediaQueryMobileSmallMax,
} from 'styles';

export const BodyRow = styled.tr`
  height: 48px;
  background: ${({ $isHighlighted, $isEven }) => {
    if ($isHighlighted) {
      return colorAccent50;
    }

    return $isEven ? colorGrey50 : colorWhite;
  }};
  border-bottom: 1px solid ${colorGrey75};

  &:first-child {
    box-shadow: inset 0 1px 0 ${colorGrey75};
  }

  &:last-child {
    border-bottom: 0;
  }
`;

export const DateCell = styled.td`
  padding: 0 16px;
  font-size: 14px;
  line-height: 28px;
  color: ${colorBlack200};
  white-space: nowrap;
  vertical-align: middle;

  @media ${mediaQueryMobileSmallMax} {
    padding: 0 8px;
  }
`;

export const RateCell = styled.td`
  padding: 0 16px;
  text-align: left;
  vertical-align: middle;

  @media ${mediaQueryMobileSmallMax} {
    padding: 0 8px;
  }
`;
